import React, { useState } from 'react';
import {
  Drawer,
  Typography,
  Input,
  Button,
  Switch,
  Table,
  Space,
  Tag
} from 'antd';
import {
  CheckCircleTwoTone,
  SyncOutlined
} from '@ant-design/icons';

const { Title, Text } = Typography;

const CommandDrawer = ({ visible, onClose }) => {
  const [version, setVersion] = useState('11.2.95');
  const [useBackup, setUseBackup] = useState(false);

  const columns = [
    {
      title: 'Server',
      dataIndex: 'name',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (status) =>
        status === 'ok' ? (
          <CheckCircleTwoTone twoToneColor="#52c41a" />
        ) : (
          <SyncOutlined spin />
        ),
    },
    {
      title: 'Performance',
      dataIndex: 'performance',
      render: (performance) =>
        performance ? <SyncOutlined spin /> : <CheckCircleTwoTone twoToneColor="#52c41a" />,
    },
  ];

  const data = [
    {
      key: '1',
      name: 'Core Server',
      status: 'ok',
      performance: true,
    },
    {
      key: '2',
      name: 'Document Server',
      status: 'ok',
      performance: false,
    },
    {
      key: '3',
      name: 'Reports',
      status: 'ok',
      performance: false,
    },
  ];

  return (
    <Drawer
      title="⚡ Server Status"
      placement="right"
      zIndex={1050}
      closable
      onClose={onClose}
      visible={visible}
      width={400}
    >
      <div style={{ marginBottom: 20 }}>
        <Text strong>Version:</Text>
        <Input
          style={{ width: '100px', marginLeft: 10 }}
          value={version}
          onChange={(e) => setVersion(e.target.value)}
        />
      </div>

      <div style={{ textAlign: 'center', marginBottom: 20 }}>
        <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: '32px' }} />
        <Title level={5}>All servers are fully operational</Title>
        <Text type="secondary">If you encounter any degraded servers, please contact Axxis Systems support center.</Text>
      </div>

      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        size="small"
      />

      <Space style={{ marginTop: 20, display: 'flex', justifyContent: 'space-between' }}>
        <Button type="primary">Update Version</Button>
        <div>
          <Text>Use backup environment</Text>
          <Switch
            style={{ marginLeft: 10 }}
            checked={useBackup}
            onChange={setUseBackup}
          />
        </div>
      </Space>
    </Drawer>
  );
};

export default CommandDrawer;
